import { ChangeDetectionStrategy, Component } from '@angular/core';

import { title } from '@softline/application';
import { PageComponent, PageHeaderComponent } from '@softapps/core/pages';
import { translator} from '@softline/ui-core';
import { RouterLink } from '@angular/router';

import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-overview',
  imports: [
    RouterLink,
    PageComponent,
    PageHeaderComponent,
    TranslatePipe],
  templateUrl: './overview.component.html',
  styleUrl: './overview.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush })
export class OverviewComponent {
  readonly t = translator();

  constructor() {
    title(() => this.t('#WIEGUNG.TITLE')());
  }
}
